import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Switch } from './switch.class';

export class Page {

    constructor() {

        // Paddle initialisieren
        Paddle.Setup({ vendor: 120516 });

        // Paket bestellen
        const $btnOrder = document.querySelector('button.order');
        const $inputBilling = document.querySelector('input[name=billing_yearly]');
        if($btnOrder) {

            // Switch
            const $showPriceAnnual = document.querySelector(".show-price-annual");
            const $showPriceMonthly = document.querySelector(".show-price-monthly");
            document.querySelector('#switch_upgrade_billing').addEventListener('change', event => {
                if(event.detail.switch.isActivated()) {
                    $showPriceAnnual.classList.remove("hidden");
                    $showPriceMonthly.classList.add("hidden");
                } else {
                    $showPriceAnnual.classList.add("hidden");
                    $showPriceMonthly.classList.remove("hidden");
                }
            });

            // Bestellung
            $btnOrder.addEventListener('click', event => {

                const switchInstance = new Switch("#switch_upgrade_billing");
                const isYearly = switchInstance.isActivated();

                let productId = 0;
                if(isYearly)  productId = parseInt( event.currentTarget.getAttribute('data-productid-yearly') );
                else          productId = parseInt( event.currentTarget.getAttribute('data-productid-monthly') );

                const account_email = event.currentTarget.getAttribute('data-account-email');
                const account_id = parseInt( event.currentTarget.getAttribute('data-account-id') );
                const locale = event.currentTarget.getAttribute('data-locale');
                const title = event.currentTarget.getAttribute('data-title');
                const plan = event.currentTarget.getAttribute('data-plan');
                const referrer = event.currentTarget.getAttribute('data-referrer');

                const passthrough = {};
                if(account_id)      passthrough.account_id = account_id;
                if(referrer)        passthrough.referrer = referrer;

                Paddle.Checkout.open({
                    product: productId,
                    email: account_email,
                    passthrough: JSON.stringify(passthrough),
                    successCallback: data => {

                        // Weiterleitung zu Seite Order-Processing
                        App.gotoUrl(App.getUrl('membership', 'order_processing', '', { paddle_user_id: data.user.id, to_plan: plan, lang: locale }));
                    },
                    allowQuantity: false,
                    locale: locale,
                    title: title,
                });
            });
        }

        // Abo updaten
        const $btnUpdate = document.querySelector('button.update');
        if($btnUpdate) {
            $btnUpdate.addEventListener('click', event => {

                const update_url = event.currentTarget.getAttribute('data-update-url');
                const success_url = event.currentTarget.getAttribute('data-success-url');
                const locale = event.currentTarget.getAttribute('data-locale');

                Paddle.Checkout.open({
                    override: update_url,
                    success: success_url,
                    locale: locale,
                });
            });
        }

        // Abo kündigen
        const $btnCancel = document.querySelector('button.cancel');
        if($btnCancel) {
            $btnCancel.addEventListener('click', event => {

                const cancel_url = event.currentTarget.getAttribute('data-cancel-url');
                const success_url = event.currentTarget.getAttribute('data-success-url');
                const locale = event.currentTarget.getAttribute('data-locale');

                Paddle.Checkout.open({
                    override: cancel_url,
                    success: success_url,
                    locale: locale,
                });
            });
        }
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('membership')) {
        new Page();
    }
});